function __subscription(unsubscribeFunction) {
    function unsubscribe() {
        unsubscribeFunction();
    }

    function merge(other) {
        return __subscription(() => {
            unsubscribe();
            other.unsubscribe();
        });
    }

    return {
        unsubscribe: unsubscribe,
        merge: merge,
    };
}

function __createStream(notify, subscribe) {
    return {
        notify: notify,
        subscribe: subscribe,
    };
}

function eventSource() {
    const subscribers = [];

    function notify(...callbackArgs) {
        subscribers.forEach((subscriber) => {
            subscriber.apply(this, callbackArgs);
        });
    }

    function subscribe(callback) {
        subscribers.push(callback);
        return __subscription(() => subscribers.pop(callback));
    }

    return __createStream(notify, subscribe);
}

function never() {
    function notify() {
        // do nothing
    }

    function subscribe() {
        return __emptySubscription;
    }

    return __createStream(notify, subscribe);
}

const __emptySubscription = __subscription(() => undefined);

module.exports = {
    eventSource: eventSource,
    never: never,
    emptySubscription: __emptySubscription,
};
